/**
 * Keeps header overlays (menu drawer, search modal, cart drawer, quick-add
 * modal, localization drawers, etc.) mutually exclusive.
 *
 * The menu drawer is a <details>/<summary> toggle while search/cart/quick-add
 * are native <dialog> elements opened via showModal() — two unrelated
 * mechanisms that don't know about each other, so it's possible (usually a
 * timing/double-click thing) to end up with more than one open at once.
 * That was already possible before, it just wasn't visible because every
 * overlay had an opaque background covering whatever was open underneath.
 * Now that some overlays use a translucent/blurred background, a stray
 * still-open dialog shows through as visual clutter — this closes whichever
 * overlays are NOT the one that just opened.
 */
(function () {
  'use strict';

  function openDetails() {
    return [].slice.call(document.querySelectorAll('header-drawer details[open], .menu-drawer-container details[open]'));
  }

  function openDialogs() {
    return [].slice.call(document.querySelectorAll('dialog[open]'));
  }

  // Walk up from a native <details>/<dialog> to the custom element that owns
  // its open/close lifecycle (scroll-lock, focus-trap, animation classes),
  // and close it through that element's own API. Touching the native
  // open/close state directly (removeAttribute('open'), dialog.close())
  // skips that cleanup: scroll-lock never gets released because unlockScroll()
  // is only called from inside these components' own close methods, and for
  // the drawer specifically its full-screen backdrop is shown/hidden by a
  // CSS class the component's close() removes -- not by the native [open]
  // attribute -- so a raw removeAttribute leaves the backdrop stuck visible
  // and blocking every click.
  function closeViaOwner(el) {
    var node = el.parentElement;
    while (node) {
      if (typeof node.close === 'function') {
        node.close();
        return true;
      }
      if (typeof node.closeDialog === 'function') {
        node.closeDialog();
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function closeAllExcept(keep) {
    // A <details> accordion (e.g. the cart discount field) can live inside
    // an already-open <dialog> (the cart drawer). Toggling it open fires
    // this same 'toggle' listener, and without this containment check the
    // drawer reads as "some other open overlay" and gets closed out from
    // under the thing the user just opened.
    openDetails().forEach(function (d) {
      if (d === keep || d.contains(keep)) return;
      if (!closeViaOwner(d)) d.removeAttribute('open');
    });
    openDialogs().forEach(function (d) {
      if (d === keep || d.contains(keep)) return;
      if (!closeViaOwner(d) && typeof d.close === 'function') d.close();
    });
  }

  document.addEventListener(
    'toggle',
    function (ev) {
      var details = ev.target;
      if (details.tagName === 'DETAILS' && details.open) {
        closeAllExcept(details);
      }
    },
    true
  );

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var el = m.target;
      if (el.tagName === 'DIALOG' && el.open) {
        closeAllExcept(el);
      }
    });
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });
})();
